import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import RelativeParser from "../../../ui/utils/RelativeParser";
import { PageSizeContext } from "../../../ui/context/page/PageSizeContext";
import { DraftContext} from "../context/DraftContext";
import { TYPES } from "../../../config/constants/typesReducers";
import { DEFAULT_DATE_FORMAT } from "../../../ui/utils/dateFormat";

const { ADD_FIELD } = TYPES.DRAFT;



export const useFieldsForm = (fieldsFormRef) => {
    const { pageSize } = useContext(PageSizeContext);
    const { draftState:{ draft:{ signers } }, draftDispatch } = useContext(DraftContext);

    const [currentSigner, setSigner] = useState(signers[Object.keys(signers)[0]]);

    const [statusGhostField, setStatusGhostField] = useState({
        isActive: false,
        data: {}
    });

    const ghostElementRef = useRef(null);   //Elemento fantasma
    
    let coords = useMemo(() => ({
        x: 0,
        y: 0,
    }), []);

    const createGhostElement = useCallback((element) => {

        ghostElementRef.current = element;
        ghostElementRef.current.classList.remove(["fields__item-form", "active"]);
        const p = ghostElementRef.current.getElementsByTagName("p");
        ghostElementRef.current.removeChild(p[0]);

        ghostElementRef.current.className = "fields__item-ghost";

        document.body.appendChild(ghostElementRef.current);
    },[]);

    //? Manejadores de eventos
    //Actualiza las coordenadas del elemento fantasma al mover el mouse
    const moveGhostElement = useCallback(() => {
        const {scrollX, scrollY} = window;
        const {clientX: x, clientY: y, target} = event;

        const styleGhostElement = ghostElementRef.current.style;

        console.log(target.tagName);

        target.tagName === 'CANVAS' ? styleGhostElement.borderColor = 'var(--primary-color)' : styleGhostElement.borderColor = 'transparent';

        //Actualiza las coordenadas del cursor
        coords.x = x;
        coords.y = y;

        //Elemento fantasma sigue al cursor
        ghostElementRef.current.style.left = `${(coords.x + scrollX)-90}px`;
        ghostElementRef.current.style.top = `${(coords.y + scrollY)-30}px`;

    },[coords]);

    //Actualiza las coordenadas del elemento fantasma al hacer scroll
    const scrollGhostElement = useCallback(() =>{
        const {scrollX, scrollY} = window;

        //Elemento fantasma sigue al cursor
        ghostElementRef.current.style.left = `${(coords.x + scrollX)-90}px`;
        ghostElementRef.current.style.top = `${(coords.y + scrollY)-30}px`;
    },[coords.x, coords.y]);
    

    //Evento click si el elemento fantasma esta activo
    const clickGhostElement = useCallback((event) => {
        const { offsetX, offsetY, target } = event;
        
        // Si el usuario hizo clic en el canvas inserta el campo
        if (target.tagName === 'CANVAS') {
            console.log(target);
            const { id } = target;
            const { signerId, type } = statusGhostField.data;

            const pageId = parseInt(id.slice(5));
            const {pageWidth, pageHeight} = pageSize;

            // Obtener coordenadas relativas del campo respecto al contenedor del PDF -> {x: 50%, y: 30%}
            const relativeCoords = RelativeParser.pixelsToPercentage(offsetX-90, offsetY-30, pageWidth, pageHeight);

            const action = {
                type: ADD_FIELD,
                payload: {
                    page: pageId,
                    field: {
                        type,
                        signerId,
                        ...(type === 'date' && { dateFormat: DEFAULT_DATE_FORMAT }),
                        position: {
                            page: pageId,
                            size: {
                                width: '15%',
                                height: '6%'
                            },
                            coords: {
                                x: relativeCoords.x,
                                y: relativeCoords.y
                            }
                        }
                    }
                }
            }

            draftDispatch(action);
        }
        
        setStatusGhostField({ isActive: false, data: {} });
        
    }, [statusGhostField, pageSize, draftDispatch]);

    // Efecto secundario para actualizar la clase CSS
    useEffect(() => {
        const {isActive, data} = statusGhostField;
        const {current: currentFieldForm} = fieldsFormRef;
        if (!isActive) return;

        // Actualizar la clase CSS del campo activo y deshabilitar los hermanos
        data.element.classList.toggle("active", isActive);

        Array.from(fieldsFormRef.current.children).forEach((sibling) => {
            if (sibling !== data.element) {
                sibling.classList.toggle("disabled", isActive);
            }
        });

        setTimeout(() => {
            window.addEventListener("mousemove", moveGhostElement);
            window.addEventListener("scroll", scrollGhostElement);
            window.addEventListener("click", clickGhostElement);
        }, 1);

        return () => {
            data.element.classList.toggle("active", !isActive);

            Array.from(currentFieldForm.children).forEach((sibling) => {
                sibling.classList.toggle("disabled", !isActive);
            });

            window.removeEventListener("mousemove", moveGhostElement);
            window.removeEventListener("scroll", scrollGhostElement);
            window.removeEventListener("click", clickGhostElement);

            if (ghostElementRef.current) {
                document.body.removeChild(ghostElementRef.current);
                ghostElementRef.current = null;
            }
        }
    }, [clickGhostElement, fieldsFormRef, moveGhostElement, scrollGhostElement, statusGhostField, statusGhostField.isActive]);
    
    const handleClickField = (event, field, signer) => {
        setStatusGhostField((prevState) => {
            const newValue = !prevState.isActive;

            // Si el campo esta activo 
            if (newValue) {
                const {target} = event;

                const data = {
                    isActive: newValue,
                    data: {
                        element: target,
                        signerId: signer.id,
                        type: field.type
                    }
                };
                createGhostElement(target.cloneNode(true));
                return data;
            }
            
            return {
                isActive: newValue,
                data: {}
            }
        });
    }

    return {
        signers,
        currentSigner,
        setSigner,
        handleClickField
    }
}

